module.exports = __webpack_public_path__ + "static/Background-voter-3.95097b55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-voter-3.jpg
// module id = 480
// module chunks = 265584890008614